import type { IconSvgObject } from './types';

const Chair02Icon: IconSvgObject = [
  ["path", { d: "M7 15V22M17 15V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 14V15H18V14C18 13.0917 17.4538 12.2724 16.6154 11.9231C13.6615 10.6923 10.3385 10.6923 7.38462 11.9231C6.54616 12.2724 6 13.0917 6 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 12L6.32985 5.29851C6.15325 3.53246 7.5401 2 9.31496 2H14.685C16.4599 2 17.8468 3.53246 17.6701 5.29851L17 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 18L17 18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Chair02Icon;
